import client from './client';

// 로그인
export const login = async (email, password) => {
  const response = await client.post('/auth/login', { email, password });
  const { access_token, refresh_token } = response.data;
  
  localStorage.setItem('access_token', access_token);
  localStorage.setItem('refresh_token', refresh_token);
  
  return response.data;
};

// 회원가입
export const register = async (data) => {
  const response = await client.post('/auth/register', data);
  return response.data;
};

// 로그아웃
export const logout = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  window.location.href = '/login';
};

// 내 정보 조회
export const getMe = async () => {
  const response = await client.get('/auth/me');
  return response.data;
};

// 로그인 상태 확인
export const isAuthenticated = () => {
  return !!localStorage.getItem('access_token');
};
